import styled from 'styled-components'

export const HeaderContainer = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
gap: 1rem;
padding: 1.5rem 2rem 1rem 2rem;
background-color: white;

img{
  max-height: 5rem;
  max-width: 10rem;
  object-fit: scale-down;
}

@media(max-width: 480px){
  padding: 1rem 1.25rem .75rem 1.25rem;

  h1{
    font-size: 1.375rem;
    line-height: 1.75rem;
  }

  img{
    max-height: 3rem;
    max-width: 6rem;
  }
}
`

export const Container = styled.div`
background-color: white;
padding: 2rem 2rem 3rem 2rem;
height: 100%;

@media(max-width: 480px){
  padding: 1.5rem 1.25rem 2.5rem 1.25rem;
}
`
